/* src/app/views/admin/account-info/account-info.component.css */
.ltr {
  direction: ltr;
  text-align: left;
}
/*# sourceMappingURL=account-info.component.css.map */
